module.exports = __webpack_public_path__ + "static/img/ai-pdf.4ec3bd65.png";